<template>
  <div class="product_item">
    <div class="product_image">
      <img :src="product.image" />
    </div>
    <div class="product_details">
      <h6>
        <span class="mr-3">Product Name:</span>
        {{ product.name }}
      </h6>
      <h6>
        <span class="mr-3">Product Price:</span>
        &#8358;{{ addComma(product.price) }}
      </h6>
      <h6>
        <span class="mr-3">Category:</span>
        {{ product.category }}
      </h6>
      <h6>
        <span class="mr-3">Product Description:</span>
      </h6>
      <p>{{ product.description }}</p>
      <div class="mt-4">
        <input
          type="number"
          @blur="updateInput($event)"
          :min="1"
          class="quantityCount"
          v-model.number="quantity"
        />
        <button class="btn btn-success" @click="addToCart()" v-if="!product.selected">
          <i class="fa fa-cart-plus mr-2" v-if="!processing" aria-hidden="true"></i>
          <span
            class="spinner-border spinner-border-sm mr-2"
            role="status"
            v-if="processing"
            aria-hidden="true"
          ></span>
          Add To Cart
        </button>
        <router-link
          v-if="product.selected && !processing"
          to="/mbclothing/cart"
          class="btn btn-primary"
        >
          <i class="fa fa-shopping-bag mr-2" aria-hidden="true"></i>View
          cart
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SingleProduct",
  props: ["product"],
  data() {
    return {
      processing: false,
      quantity: 1
    };
  },
  methods: {
    addToCart() {
      this.processing = true;
      setTimeout(() => {
        this.processing = false;
        this.AddToState();
      }, 2000);
    },

    AddToState: function() {
      let quantity = this.quantity;
      if (quantity <= 0) {
        quantity = 1;
      }
      this.$store.dispatch("addProductToCart", {
        product: this.product,
        quantity: quantity
      });
    },
    addComma: function(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    updateInput: function(event) {
      if (event.target.value < event.target.min) {
        event.target.value = 1;
      }
    }
  }
};
</script>

<style></style>
